export default "__VITE_ASSET__FR2wReux__"